import { request } from "@/lib/api";
import { HTTP_METHODS } from "@/constants/httpMethods";
import API_URLS from "@/constants/apiUrls";

/**
 * Car Home Service
 * Araç ana sayfa (home) için gerekli section API isteklerini yönetir.
 * Tüm metodlar POST çağrısı yapar ve aynı imzayı paylaşır.
 *
 * Not: Endpoint URL'leri `API_URLS.hotel.home.*` altında beklenir.
 * URL değerleri ayrı dosyada tanımlanacağından burada sadece anahtarlar kullanılır.
 */
export const carHomeService = {
  /**
   * Popüler tatil bölgelerini getirir
   * @param {Object} payload - API payload
   * @param {string} [payload.LanguageCode] - Dil kodu (örn: "tr", "en")
   * @param {string} [payload.CurrencyCode] - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Özel hata yönetimi kullanılsın mı
   * @returns {Promise<any>} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CurrencyCode": "TRY"
   * }
   */
  getPopularLocations: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.car.home.getPopularLocations,
      payload,
      headers,
      hasErrorHandler,
    }),


  /**
   * Neden Turna sayfası içeriğini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr"
   * }
   */
  getWhyTurna: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.car.home.getWhyTurna,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Popüler kiralık araç listesini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CurrencyCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "TR"
   *   "CurrencyCode": "TRY"
   * }
   */
  getPopularCars: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.car.home.getPopularCars,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Popüler firma listesini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "TR"
   * }
   */
  getPopularCompanies: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.car.home.getPopularCompanies,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Popüler kiralama noktaları listesini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "TR"
   * }
   */
  getPopularRentalLocations: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.car.home.getPopularRentalLocations,
      payload,
      headers,
      hasErrorHandler,
    }),
};

export default carHomeService;


